import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import Navbar from "./features/navbar/Navbar.jsx";
import ScrollToTop from "./shared/utils/ScrollToTop";
import Footer from "./features/footer/Footer";
import "./shared/styles/global.css";
import GiftBoxCTA from "./shared/components/ctaBox/GiftBoxCTA";

// Lazy loaded pages — load only when visited
const Home = lazy(() => import("./features/home/Home"));
const About = lazy(() => import("./features/about/About"));
const Portfolio = lazy(() => import("./features/portfolio/Portfolio"));
const PortfolioDetails = lazy(
  () => import("./features/portfolio/ProjectDetails")
);
const Contact = lazy(() => import("./features/contact/Contact"));
const Testimonial = lazy(() => import("./features/testimonial/Testimonials"));
const Services = lazy(() => import("./features/services/Services"));
const Story = lazy(() => import("./features/story/StoryDetails"));
const NotFound = lazy(() => import("./features/notFound/NotFound"));

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      {/* Suspense shows loader while page loads */}
      <Suspense
        fallback={
          <div className="page-loader">
            <div className="page-loader-spinner"></div>
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/testimonial" element={<Testimonial />} />
          <Route path="/services" element={<Services />} />
          <Route path="/story" element={<Story />} />
          <Route path="/portfolio-details/:id" element={<PortfolioDetails />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <GiftBoxCTA />
      <Footer />
    </Router>
  );
}

export default App;
